import { RequestRelatorioReceitaDTO } from './integracao-contabil/RequestRelatorioReceitaDTO';
import { AxiosRequestConfig } from "axios"; // @ts-ignore
import { integracaoContabilApiConfig } from "./config";
import Api from "./Api";
import { RequestRelatorioContaReceberDTO } from "./integracao-contabil/RequestRelatorioContaReceberDTO";
import { RequestRelatorioFaturamentoBrutoDTO } from "./integracao-contabil/RequestRelatorioFaturamentoBrutoDTO";
import { RequestRelatorioOrcamentoFrotaDTO } from "./integracao-contabil/RequestRelatorioOrcamentoFrotaDTO";
import { RequestRelatorioContaPagarDTO } from "./integracao-contabil/RequestRelatorioContaPagarDTO";
import { ContaPagarValidacaoContabilModel } from "@/models/contabil/contas-pagar/ContaPagarValidacaoContabilModel";
import { RequestResetSenhaDTO } from "./auth/RequestResetSenhaDTO";
import { RequestValidacaoContabilDTO } from "./integracao-contabil/RequestValidacaoContabilDTO";
import { RequestValidacaoConstabilPorStatusDTO } from "./integracao-contabil/RequestValidacaoConstabilPorStatusDTO";
import { RelatorioDataCemproDTO } from "./integracao-contabil/RequestRelatorioDataCemproDTO";
import { RelatorioServicosVeicularesModel } from '@/models/administracao/servicos-veiculares/RelatorioServicosVeicularesModel';
import { RelatorioServicosSaudeModel } from '@/models/administracao/servicos-saude/RelatorioServicosSaudeModel';
import { RequestRelatorioDiretivoDTO } from './gerencial/RequestRelatorioDiretivoDTO';
import { RelatorioAssociadosInativosModel } from '@/models/administracao/associados-inativos/RelatorioAssociadosInativosModel';

export class IntegracaoContabilApi extends Api {
  constructor(config: AxiosRequestConfig) {
    super(config);
  }

  solicitarResetSenha(req: RequestResetSenhaDTO) {
    return this.post<RequestResetSenhaDTO>("/usuarios/resetSenha", req);
  }

  gerarRelatorioContasReceber(
    requestRelatorioContaReceberDTO: RequestRelatorioContaReceberDTO
  ): Promise<any> {
    return this.post<RequestRelatorioContaReceberDTO>(
      "/relatorio/conta-receber",
      requestRelatorioContaReceberDTO,
      {
        responseType: "arraybuffer",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/pdf",
        },
      }
    );
  }

  gerarRelatorioContasReceberExcel(
    requestRelatorioContaReceberDTO: RequestRelatorioContaReceberDTO
  ): Promise<any> {
    return this.post<RequestRelatorioContaReceberDTO>(
      "/relatorio/conta-receber/xls",
      requestRelatorioContaReceberDTO,
      {
        responseType: "arraybuffer",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/x-xls",
        },
      }
    );
  }

  gerarRelatorioFaturamentoBruto(
    requestRelatorioFaturamentoBrutoDTO: RequestRelatorioFaturamentoBrutoDTO
  ): Promise<any> {
    return this.post<RequestRelatorioFaturamentoBrutoDTO>(
      "/relatorio/faturamento-bruto",
      requestRelatorioFaturamentoBrutoDTO,
      {
        responseType: "arraybuffer",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/pdf",
        },
      }
    );
  }

  consultarRelatorioOrcamentoFrota(filtroDTO: RequestRelatorioOrcamentoFrotaDTO) {
    return this.post<RequestRelatorioOrcamentoFrotaDTO>(
      "/relatorio/orcamento-frota/consultar",
      filtroDTO,
    );
  }

  gerarRelatorioOrcamentoFrota(
    requestRelatorioOrcamentoFrotaDTO: RequestRelatorioOrcamentoFrotaDTO
  ): Promise<any> {
    return this.post<RequestRelatorioFaturamentoBrutoDTO>(
      "/relatorio/orcamento-frota",
      requestRelatorioOrcamentoFrotaDTO,
      {
        responseType: "arraybuffer",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/pdf",
        },
      }
    );
  }

  gerarRelatorioOrcamentoFrotaExcel(
    requestRelatorioOrcamentoFrotaDTO: RequestRelatorioOrcamentoFrotaDTO
  ): Promise<any> {
    return this.post<RequestRelatorioOrcamentoFrotaDTO>(
      "/relatorio/orcamento-frota/xls",
      requestRelatorioOrcamentoFrotaDTO,
      {
        responseType: "arraybuffer",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/x-xls",
        },
      }
    );
  }

  gerarRelatorioFaturamentoBrutoExcel(
    requestRelatorioFaturamentoBrutoDTO: RequestRelatorioFaturamentoBrutoDTO
  ): Promise<any> {
    return this.post<RequestRelatorioFaturamentoBrutoDTO>(
      "/relatorio/faturamento-bruto/xls",
      requestRelatorioFaturamentoBrutoDTO,
      {
        responseType: "arraybuffer",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/x-xls",
        },
      }
    );
  }

  gerarRelatorioContasPagar(
    requestRelatorioContaPagarDTO: RequestRelatorioContaPagarDTO
  ): Promise<any> {
    return this.post<RequestRelatorioContaPagarDTO>(
      "/relatorio/conta-pagar",
      requestRelatorioContaPagarDTO,
      {
        responseType: "arraybuffer",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/pdf",
        },
      }
    );
  }

  gerarRelatorioContasPagarExcel(
    requestRelatorioContaPagarDTO: RequestRelatorioContaPagarDTO
  ): Promise<any> {
    return this.post<RequestRelatorioContaPagarDTO>(
      "/relatorio/conta-pagar/xls",
      requestRelatorioContaPagarDTO,
      {
        responseType: "arraybuffer",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/x-xls",
        },
      }
    );
  }

  gerarRelatorioDataCempro(
    tipo: string,
    requestDataCemproDTO: RelatorioDataCemproDTO
  ): Promise<any> {

    let dataInicio = requestDataCemproDTO.inicio ?? '';
    let dataFim = requestDataCemproDTO.fim ?? '';

    let urlParam = `/relatorio/datacempro?dataInicio=${dataInicio}&dataFim=${dataFim}`;

    return this.get<RelatorioDataCemproDTO>(
      urlParam,
      {
        responseType: "arraybuffer",
        headers: {
          "Content-Type": "application/json",
          Accept: "text/plain",
        },
      }
    );
  }

  gerarRelatorioReceita(
    tipo: string,
    requestDTO: RequestRelatorioReceitaDTO
  ): Promise<any> {
    return this.post<RequestRelatorioReceitaDTO>(
      tipo.toLocaleLowerCase() === 'pdf' ? "/relatorio/receita" : '/relatorio/receita/xls',
      requestDTO,
      {
        responseType: "arraybuffer",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/x-xls",
        },
      }
    );
  }

  gerarPagamentos(idsSelecionado: number[]): Promise<any> {
    return this.post("/conta-pagar/gerar-pagamento", idsSelecionado, {
      responseType: "arraybuffer",
    });
  }

  listarContasPagar(): Promise<ContaPagarValidacaoContabilModel[]> {
    return this.get<ContaPagarValidacaoContabilModel[]>("/conta-pagar/")
      .then((res) => {
        const { data } = res;
        return data;
      })
      .catch((err) => {
        throw new Error("Falha ao obter lista de contas a pagar");
      });
  }

  filtrarValidacaoContabil(filtroDTO: RequestValidacaoContabilDTO) {
    return this.post<RequestValidacaoContabilDTO>(
      "/conta-pagar/filtro-periodo-e-status",
      filtroDTO,
    );
  }

  filtrarContaReceber(filtroDTO: RequestRelatorioContaReceberDTO) {
    return this.post<RequestRelatorioContaReceberDTO>(
      "/conta-receber/filtro-periodo-e-status",
      filtroDTO,
    );
  }

  realizarBaixa(idContaReceber: number, dataBaixaRecebimento: string) {
    return this.post(
      "/conta-receber/atualizar-recebimento", {
        idContaReceber, 
        dataBaixaRecebimento
    });
  }

  filtrarContasPagarPorStatusAprovadaEEnviadaPagamento(
    filtroPorStatus: RequestValidacaoConstabilPorStatusDTO
  ) {
    return this.post<RequestValidacaoConstabilPorStatusDTO>(
      "/conta-pagar/status-aprovada-enviada-pagamento",
      filtroPorStatus
    );
  }

  filtrarContasPagarPorStatus(
    filtroPorStatus: RequestValidacaoConstabilPorStatusDTO
  ) {
    return this.post<RequestValidacaoConstabilPorStatusDTO>(
      "/conta-pagar/filtro-status",
      filtroPorStatus
    );
  }

  atualizarStatusParaAprovada(idContaPagar: number) {
    return this.post(`/conta-pagar/atualizar-status-aprovada/`, {
      idContaPagar,
    });
  }

  atualizarStatusNFParaAprovadaSaude(notaFiscal: string) {
    return this.put(`notas-fiscais/`, {
      notaFiscal,
      status:'APROVADA'

    }, {
      baseURL: 'servicos-saude-api/atendimento/'
    });
  }

  atualizarStatusNFParaAprovadaAssintencia(notaFiscal: string) {
    return this.put(`notas-fiscais/`, {
      notaFiscal,
      status:'APROVADA'

    }, {
      baseURL: 'assistencia24h-api/servico/'
    });
  }

  atualizarStatusParaReprovada(idContaPagar: number, motivoRecusa: string): Promise<any> {
    return this.post(`/conta-pagar/atualizar-status-reprovada/`, {
      idContaPagar, motivoRecusa
    });
  }
  atualizarStatusNFParaReprovadaSaude(notaFiscal: string,  motivoRecusa:string ): Promise<any> {
    return this.put(`notas-fiscais/`, {
        motivoRecusa, 
        notaFiscal,
        status:'REPROVADA'
    },
    {
      baseURL: 'servicos-saude-api/atendimento/'
    });
  }

  atualizarStatusNFParaReprovadaAssistencia(notaFiscal: string, motivoRecusa:string): Promise<any> {
    return this.put(`notas-fiscais/`, {
      motivoRecusa, 
      notaFiscal,
      status:'REPROVADA'
    },
     {
      baseURL: 'assistencia24h-api/servico/'
    });
  }

  downloadNotaFiscal(nomeArquivo: string): Promise<any> {
    return this.get(`/nota-fiscal/download/${nomeArquivo}`, {
      responseType: "arraybuffer",
    });
  }

  downloadPedagio(idContaPagar: number): Promise<any> {
    return this.get(`/nota-fiscal/download-pedagio/${idContaPagar}`, {
      responseType: "arraybuffer",
    });
  }

  listarContaPagarStatusAprovada(status: string) {
    return this.post("/conta-pagar/status-aprovada-enviada-pagamento/", {
      status,
    });
  }

  dadosRelatorioServicosVeiculares(
    requestDTO: RelatorioServicosVeicularesModel
  ): Promise<any> {
    return this.post<RelatorioServicosVeicularesModel>(
      "/relatorio/veicular",
      requestDTO
    );
  }

  gerarRelatorioServicosVeiculares(
    tipo: string,
    requestDTO: RelatorioServicosVeicularesModel
  ): Promise<any> {
    return this.post<RelatorioServicosVeicularesModel>(
      tipo.toLocaleLowerCase() === 'pdf' ? "/relatorio/veicular/pdf" : '/relatorio/veicular/xls',
      requestDTO,
      {
        responseType: "arraybuffer",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/pdf",
        },
      }
    );
  }

  gerarRelatorioServicosSaude(
    tipo: string,
    requestDTO: RelatorioServicosSaudeModel
  ): Promise<any> {
    return this.post<RelatorioServicosSaudeModel>(
      tipo.toLocaleLowerCase() === 'pdf' ? "/relatorio/saude" : '/relatorio/saude/xls',
      requestDTO,
      {
        responseType: "arraybuffer",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/pdf",
        },
      }
    );
  }

  gerarRelatorioDiretivo(
    tipo: string,
    requestDTO: RequestRelatorioDiretivoDTO
  ): Promise<any> {
    return this.post<RelatorioServicosSaudeModel>(
      tipo.toLocaleLowerCase() === 'pdf' ? "relatorio/diretivo" : "relatorio/diretivo/xls",
      requestDTO,
      {
        responseType: "arraybuffer",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/pdf",
        }
      }
    );
  }

  diretivoDados(
    requestDTO: RequestRelatorioDiretivoDTO
  ): Promise<any> {
    return this.post<RequestRelatorioDiretivoDTO>(
      "/relatorio/diretivo/dados",
      requestDTO
    );
  }

  gerarRelatorioAssociadosInativos(
    tipo: string,
    requestDTO: RelatorioAssociadosInativosModel
  ): Promise<any> {
    return this.post<RelatorioAssociadosInativosModel>(
      tipo.toLocaleLowerCase() === 'pdf' ? "/relatorio/associado-inativo/pdf" : '/relatorio/associado-inativo/xls',
      requestDTO,
      {
        responseType: "arraybuffer",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/pdf",
        },
      }
    );
  }

  buscarAssociadosInativos(
    requestDTO: RelatorioAssociadosInativosModel
  ): Promise<any> {
    return this.post<RelatorioAssociadosInativosModel>(
      "/relatorio/associado-inativo",
      requestDTO
    );
  }
}

export const integracaoContabilApi = new IntegracaoContabilApi(
  integracaoContabilApiConfig
);
